import React from 'react';
import classnames from 'classnames';

import { useMedia } from 'util/event';

import Icon from 'components/atoms/Icon';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import ContentWrapper from 'components/atoms/ContentWrapper';
import SectionTitle from 'components/atoms/SectionTitle';
import ButtonMore from 'components/molecules/ButtonMore';

import BackgroundDesktopLeftTop from 'images/image/background-about-left-top-desktop.png';
import BackgroundDesktopRightBottom from 'images/image/background-about-right-bottom-desktop.png';
import BackgroundMobileLeftTop from 'images/image/background-about-left-top-mobile.png';
import BackgroundMobileRightBottom from 'images/image/background-about-right-bottom-mobile.png';
import ImageAbout from 'images/image/homepage-about.png';
import IconMissionSport from 'images/icon/mission-sport.inline.svg';
import IconMissionMeeting from 'images/icon/mission-meeting.inline.svg';
import IconMissionLaunch from 'images/icon/mission-launch.inline.svg';
import IconMissionLandscape from 'images/icon/mission-landscape.inline.svg';
import Logo from 'images/ci/about-logo.png';
import PartnerDotHan from 'images/image/partner-dot-han.png';
import PartnerCCS from 'images/image/partner-ccs.png';
import PartnerCTRRA from 'images/image/partner-ctrra.png';
import DecoLine1 from 'images/icon/deco-line-about-1.inline.svg';
import DecoLine2 from 'images/icon/deco-line-about-2.inline.svg';
import DecoLine3 from 'images/icon/deco-line-about-3.inline.svg';

import styles from './index.module.css';

const About: React.FC = () => {
	const media = useMedia();

	const breadcrumbs = [
		{
			label: '首頁',
			link: '/',
		},
		{
			label: '關於去動',
		},
	];

	const missionItems = [
		{
			id: 1,
			icon: IconMissionSport,
			title: '運動文化和健康生活方式',
			description: '分享關於運動資訊、知識和體驗，鼓勵人們保持健康的生活方式。',
		},
		{
			id: 2,
			icon: IconMissionMeeting,
			title: '群體參與和觀賞',
			description:
				'分享體育活動、健身課程、戶外探險等，讓人們有機會交流參與、藉此平台建立，共同追求健康和活力。',
		},
		{
			id: 3,
			icon: IconMissionLaunch,
			title: '創新和科技',
			description: '探討運動科技、穿戴裝備、數據分析等訊息，以提供參與者高運動效果和體驗。',
		},
		{
			id: 4,
			icon: IconMissionLandscape,
			title: '環境保護和可持續性',
			description: '考慮運動對環境的影響，鼓勵環保運動，例如戶外淨灘活動、綠色運動…等。',
		},
	];

	return (
		<>
			<div className={styles.sectionAbout}>
				<div className={styles.backgroundTopLeft}>
					<img
						src={media === 'desktop' ? BackgroundDesktopLeftTop : BackgroundMobileLeftTop}
						alt=""
					/>
				</div>
				<div className={styles.backgroundRightBottom}>
					<img
						src={media === 'desktop' ? BackgroundDesktopRightBottom : BackgroundMobileRightBottom}
						alt=""
					/>
				</div>
				<ContentWrapper>
					<Breadcrumbs items={breadcrumbs} />
					<div className={styles.contentWrapper}>
						<div className={styles.content}>
							<SectionTitle className={styles.sectionTitle} title="關於去動" subTitle="about" />
							<article>
								<p>
									去動，帶著動令，滿載活力，促進人們積極參與運動，同時去鼓勵探索和冒險的精神。去動不僅是一個名稱，更是一個激勵人心的使命，讓我們一起去發現新事物，保持活力，並共同創造更美好的未來。
								</p>
								<p>
									去動的創立，善用線上技術、串聯線下活動與各方資源，蒐集海內外各大賽事活動資料，包含籃球、排球、棒球、自行車、足球、路跑、國際馬拉松、瑜珈、訓練、運動論壇及博覽會…等等，用數據驅動決策，成為提供更貼合參與者的運動內容與服務的整合型賽事平台，彈指間就能享受精彩多元的運動休閒娛樂，豐富自己的生活。
								</p>
								<p>
									去動目標，擴大資源整合為宗旨，積極連結世界各大城市的運動休閒賽事與活動，讓國人有機會利用此健康大平台，走出台灣，以運動休閒交流，擴大生命視野，找出自己熱情，從中參與，積累出一頁頁活力、健康、精彩的篇章。
								</p>
							</article>
						</div>
						<div className={styles.image}>
							<img src={ImageAbout} alt="" />
						</div>
					</div>
				</ContentWrapper>
			</div>
			<div className={styles.sectionMission}>
				{media === 'desktop' && (
					<div className={styles.decoLineTop}>
						<DecoLine1 />
					</div>
				)}
				<ContentWrapper>
					<SectionTitle
						className={styles.sectionTitle}
						type="category"
						size="fixed-size-mobile-desktop"
						title="去動使命"
						pattern="reverse"
					/>
					<ul className={styles.missionList}>
						{missionItems.map(item => (
							<li key={item.id} className={styles.missionItem}>
								<div className={styles.number}>0{item.id}</div>
								<Icon className={styles.icon} src={item.icon} />
								<p className={styles.title}>{item.title}</p>
								<p className={styles.description}>{item.description}</p>
							</li>
						))}
					</ul>
					<div className={styles.block}>
						{media === 'desktop' && (
							<div className={styles.decoLine}>
								<DecoLine2 />
							</div>
						)}
						<div className={styles.blockItem}>
							<div className={styles.title}>視覺元素</div>
							<div className={styles.content}>
								「7DON去動」作為中英合併的文字標誌(TYPE LOGO)，
								內含無限循環意念(Infinite)，讓動能永不停歇，熱情正向循環。
							</div>
						</div>
						<div className={styles.blockItem}>
							<div className={styles.title}>色彩應用</div>
							<div className={styles.content}>
								<p>
									以運動常見的紅藍白三色，紅色(活力和競爭力)，藍色(思考與智慧)、白色(宏觀與無界限)，傳達出「去動」的色彩表徵，去引導群眾印象記憶。
								</p>
								<div className={styles.colorWrapper}>
									<div className={classnames(styles.color, styles.red)}>
										<div>
											<p className={styles.label}>紅色</p>
											<p className={styles.tags}>#活力 #競爭力</p>
										</div>
									</div>
									<div className={classnames(styles.color, styles.blue)}>
										<div>
											<p className={styles.label}>藍色</p>
											<p className={styles.tags}>#思考 #智慧</p>
										</div>
									</div>
									<div className={classnames(styles.color, styles.white)}>
										<div>
											<p className={styles.label}>白色</p>
											<p className={styles.tags}>#宏觀 #無界限</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className={styles.blockItem}>
							<div className={styles.title}>設計的思路</div>
							<div className={styles.content}>
								7don 是「去動」諧音，如同我們常聽到「1700」=「一起動動」，7 前面加個 1 變成17
								(一起)，don 後面加個 e (done)，就是完成的意思。
								<br />
								<br />
								你起身去動，因而達成一件挑戰，突破，體驗…希望大家能擁有那份感動！ 去動無限可能 !
								數據驅動決策 !
							</div>
						</div>
						<div className={styles.logo}>
							<img src={Logo} alt="logo" />
						</div>
					</div>
				</ContentWrapper>
				{media === 'desktop' && (
					<div className={styles.decoLineBottom}>
						<DecoLine3 />
					</div>
				)}
			</div>
			{/* 因為客戶與合作夥伴的合作關係未確認，暫時移除該區塊 */}
			{/* <div className={styles.sectionPartner}>
				<ContentWrapper className={styles.container}>
					<SectionTitle
						className={styles.sectionTitle}
						type="category"
						size="fixed-size-mobile-desktop"
						title="合作夥伴"
					/>
					<div className={styles.blockWrapper}>
						<div className={styles.block}>
							<div>
								<div className={styles.logo}>
									<img src={PartnerDotHan} alt="" />
								</div>
								<p className={styles.title}>Dot Han 大漢集團</p>
								<p className={styles.description}>
									大漢整合行銷，成立於 2009/04/01，集合了行銷、企劃、設計等各領域的專業人才。
									無微不至的客戶服務 追求卓越的活動品質，是大漢持續追求的目標。
									在有限的人力與經費下，創造最高的活動效益，就是大漢獨一無二的專長。
								</p>
							</div>
							<ButtonMore className={styles.button} isExternal link="https://www.dothan.com.tw" />
						</div>
						<div className={styles.block}>
							<div>
								<div className={styles.logo}>
									<img src={PartnerCCS} alt="" />
								</div>
								<p className={styles.title}>中華民國文化休閒運動協會</p>
								<p className={styles.description}>
									中華民國文化休閒運動協會 (CTCLSA – Chinese Taipei Cultural Leisure & Sport
									Association)創立於 2014
									年，以提升國內休閒及運動產業發展，並擴大資源整合為宗旨，積極連結世界各大城市的運動休閒賽事與活動，讓國人有機會利用此健康大平台，走出台灣，以運動休閒交流，擴大生命視野，散發滿滿的健康能量，累績出一頁頁活力、健康、精彩的篇章。
								</p>
							</div>
							<ButtonMore className={styles.button} isExternal link="https://ctclsa.org.tw" />
						</div>
						<div className={styles.block}>
							<div>
								<div className={styles.logo}>
									<img src={PartnerCTRRA} alt="" />
								</div>
								<p className={styles.title}>中華民國路跑協會</p>
								<p className={styles.description}>
									本會創立於1993年為社團法人，以推廣及舉辦路跑、國內大型馬拉松活動為主，活動日期大部份為星期六、日，一年大約20-25場活動在全省各地舉行，已主承辦超過900場路跑賽事。
								</p>
							</div>
							<ButtonMore
								className={styles.button}
								isExternal
								link="https://www.sportsnet.org.tw"
							/>
						</div>
					</div>
				</ContentWrapper>
			</div> */}
		</>
	);
};

export default About;
